// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"fullwidth_fullWidth__31Rfj","container":"fullwidth_container__H_aZQ","blogItems":"fullwidth_blogItems__1sWmh"};